import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7bcea514"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title-separator" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { id: "communitySection" }
const _hoisted_4 = { class: "sectionContainer" }
const _hoisted_5 = {
  class: "sectionContent graphicRight",
  style: {"opacity":"1"}
}
const _hoisted_6 = { class: "sectionText" }
const _hoisted_7 = { class: "sectionTitle" }
const _hoisted_8 = { class: "text-center w-100" }
const _hoisted_9 = {
  href: "https://discord.gg/r3SacARMRs",
  target: "_blank",
  rel: "noreferer, noopener",
  class: "socialAccount"
}
const _hoisted_10 = { class: "icon" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "sr-only" }, "Discord", -1))
const _hoisted_12 = { href: "https://www.paypal.com/donate/?hosted_button_id=DPMKCQEHPKR84" }
const _hoisted_13 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t("Community")), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.$t("CommunityTitle")), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("CommunityText")), 1),
            _createElementVNode("h2", null, _toDisplayString(_ctx.$t("CommunitySubtitle")), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("CommunitySubtext")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("a", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, [
              _createVNode(_component_font_awesome_icon, { icon: ['fab', 'discord'] })
            ]),
            _hoisted_11
          ]),
          _createElementVNode("a", _hoisted_12, [
            _createElementVNode("img", {
              src: require(`@/assets/images/donationButton.svg`),
              width: "200",
              alt: "donationButton"
            }, null, 8, _hoisted_13)
          ])
        ])
      ])
    ])
  ], 64))
}